angular.module('impactx.basket').controller('BasketListCtrl',  [
    '$scope',
    'dataGen',
    '$context',
    '$redirect',
    '$securityManager',
    'selectedListItems',
    'LoginService',
    'ixaBasketActions',
    'ToastService',
    'ListHelperService',
    BasketListCtrl]);

function BasketListCtrl($scope, dataGen, $context, $redirect, $securityManager, selectedListItems, LoginService, ixaBasketActions, ToastService, ListHelperService)
{
    var ATTIBUTE_BASKET_INVISIBLE = 512;

    var ctrl = this;

    this.handleDifferentOrderCompany = function () {
        var selectedItems = JSON.parse(JSON.stringify(selectedListItems.getSelectedItems()));
        var selectedIdsWithType = selectedListItems.getSelectedIdsWithTypes();
        dataGen.postAsForm({}, {
            bkhId: selectedListItems.getFirstSelectedItem().id
        }, "/basket/checkandchangeorderright").then(function (data) {
            if (data.data.authChanged) {
                $securityManager.invalidateProcesses();
                LoginService.refreshUI(true, null, "/basket");
                ToastService.openStandardToast(data.trns.changed)
            }
            else {
                ixaBasketActions.openBasketCompanyDiffersDialog(selectedListItems.getFirstSelectedItem().id).then(function (data) {
                    if (data && data.openBasket) {
                        dataGen.post($scope, {selected: selectedIdsWithType}, "/basket/activate/changecompany", function () {
                            $context.refreshBasket({}, dataGen, $context);
                            $redirect.redirectTo(null, "/basket");
                        });
                    }
                    else if (data && data.sendBackBasket) {
                        ListHelperService.refreshListData($scope, 'basketListCtrl', {unselectRows: selectedItems});
                    }
                });
            }
        });
    }

    this.activateBasket = function()
    {
        if (selectedListItems.getFirstSelectedItem().orderCompanyDiffers == 1) {
            ctrl.handleDifferentOrderCompany();
        }
        else {
            dataGen.post($scope, {selected: selectedListItems.getSelectedIdsWithTypes()}, "/basket/activate", function () {
                $context.refreshBasket({}, dataGen, $context);
                $redirect.redirectTo(null, "/basket");
            });
        }
    };

    this.addToCurrentBasket = function()
    {
        dataGen.post($scope, {selected: selectedListItems.getSelectedIdsWithTypes()}, "/basket/addtocurrentbasket").then(function ()
        {
            $context.refreshBasket({}, dataGen, $context);
            $redirect.redirectTo(  null,"/basket");
        }, function () {
            $context.refreshBasket({}, dataGen, $context);
        });
    };

    this.createBasket = function()
    {
        if ($securityManager.isProcessAllowed("CreateBasket"))
        {
            dataGen.post($scope, {}, "/basket/create", function (data)
            {
                $context.refreshBasket({}, dataGen, $context);
                $redirect.redirectTo(null,"/basket");
            });
        }
        else if ($securityManager.isProcessAllowed("CreateProposalBasket"))
        {
            dataGen.post($scope, {}, "/basket/createproposal", function (data)
            {
                $context.refreshBasket({}, dataGen, $context);
                $redirect.redirectTo(null,"/basket");
            });
        }
    };

    this.redirectToDetail = function() {
        if (selectedListItems.getFirstSelectedItem().orderCompanyDiffers == 1) {
            ctrl.handleDifferentOrderCompany();
        }
        else {
            $redirect.redirectTo( null, "basket/" + selectedListItems.getFirstSelectedId());
        }
    };

    var canActivateBasket = function() {
        if(selectedListItems.isSingleSelection()) {
            return !selectedListItems.getFirstSelectedItem().isActive.value;
        }
        return false;
    };

    this.canExcelImportBaskets = function(additionalFields) {
        if(selectedListItems.isNoSelection() && additionalFields) {
            return additionalFields.canExcelImportBaskets;
        }
        return false;
    };

    this.getExcelImportBasketsLink = function() {
        return "excelimportbaskets";
    };


    var buttonDefinition = [
        {label: "details", action: ctrl.redirectToDetail, condition:  selectedListItems.isSingleSelection, process: 'ViewBasket'},
        {label: "activate", action: ctrl.activateBasket, condition:  canActivateBasket, process: 'ViewBasket'},
        {label: "addToBasket", action: ctrl.addToCurrentBasket, condition:  selectedListItems.isMultiSelection, process: 'AddTemplateToBasket'},
        {label: "excelimportbaskets", linkFunction: ctrl.getExcelImportBasketsLink, type:'link', condition: ctrl.canExcelImportBaskets, process: 'ExcelImportBasket'}
    ];

    this.meta = {
        rowTemplate: 'modules/basket/templates/basketlist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/basket/list',
        id: 'basketlist',
        mainActionFunction: {id:"new", action: this.createBasket, icon:"mdi-plus"},
        buttonDefinition: buttonDefinition,
        valuesInteger: [
            {name: "ATTIBUTE_BASKET_INVISIBLE", value: ATTIBUTE_BASKET_INVISIBLE}
        ]
    };
    this.getMeta = function () {
        return this.meta;
    };
}